Object.defineProperty(exports, "__esModule", { value: true });
exports.basicClasses = {
    container: {
        composes: 'content-loader',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: '#eee',
        backgroundImage: 'linear-gradient(to right, #eee 8%, #ddd 18%, #eee 33%)',
        backgroundSize: 1000,
        borderRadius: 2,
        overflow: 'hidden',
        animationName: 'contentLoaderAnimation',
        animationDuration: 1400,
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        animationFillMode: 'forwards'
    },
    '@keyframes contentLoaderAnimation': {
        from: {
            backgroundPositionX: -500,
            backgroundPositionY: 0
        },
        to: {
            backgroundPositionX: 500,
            backgroundPositionY: 0
        }
    }
};
